"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatSelectorRenderer = void 0;
const React = __importStar(require("react"));
const uom_1 = require("@genesys/uom");
const QuantityConversion = __importStar(require("@genesys/shared/lib/quantity-conversion"));
const elements_1 = require("./elements");
const FormatSelectorRenderer = ({ AmountFormatSelector, conversionParameters, onFormatChanged, onFormatSelectorActiveChanged, isQuantitySelectorActive, onQuantityChange, propertyType, onFormatCleared, selectedDecimalCount, selectedUnit, userSelected }) => {
    if (propertyType !== "amount") {
        return null;
    }
    const effectiveUnit = selectedUnit;
    const effectiveDecimalCount = selectedDecimalCount;
    const effectiveQuantity = effectiveUnit.quantity;
    if (conversionParameters === undefined || !isQuantitySelectorActive) {
        return (React.createElement(AmountFormatSelector, { onFormatChanged: onFormatChanged, onFormatCleared: onFormatCleared, selectedUnit: effectiveUnit, selectedDecimalCount: effectiveDecimalCount, onFormatSelectorActiveChanged: onFormatSelectorActiveChanged, userSelected: userSelected, unitsFormat: uom_1.UnitsFormat }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(AmountFormatSelector, { onFormatChanged: onFormatChanged, onFormatCleared: onFormatCleared, selectedUnit: effectiveUnit, selectedDecimalCount: effectiveDecimalCount, onFormatSelectorActiveChanged: onFormatSelectorActiveChanged, userSelected: userSelected, unitsFormat: uom_1.UnitsFormat }),
        conversionParameters &&
            QuantityConversion.isConvertableQuantity(effectiveQuantity) && (React.createElement(elements_1.StyledQuantitySelector, { onChange: onQuantityChange, selectedQuantity: selectedUnit.quantity }))));
};
exports.FormatSelectorRenderer = FormatSelectorRenderer;
//# sourceMappingURL=format-selector-renderer.js.map